import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import { Col } from './Col'
import { Row } from './Row'
import { FieldArray } from 'redux-form'
import styles from './CollectionViewBox.less'

class CollectionViewBoxClass extends React.Component {
  static propTypes = {
    fields: pt.array.isRequired,
    children: pt.func.isRequired,
    name: pt.string,
    keyFieldName: pt.string,
    showDivider: pt.bool
  }

  static defaultProps = {
    keyFieldName: '_key',
    showDivider: false
  }

  render () {
    const { keyFieldName, fields, children, name, showDivider, meta } = this.props

    let rows = []

    let errorMessage = meta.error

    const lastIndex = (fields.length || 0) - 1
    // get a row for each existing collection member
    fields.forEach((member, index) => {
      const memberFields = children(member, index)
      rows.push(
        <Row key={member[keyFieldName]}>
          {memberFields}
        </Row>
      )
      if (showDivider === true & index !== lastIndex) {
        if (memberFields.skipDivider !== true) {
          rows.push(<hr key={`${member[keyFieldName]}_Divider`} />)
        }
      }
    })

    if (errorMessage) {
      rows.push(
        <Row key={`${name}Error`}>
          <Col sm={12} md={12} lg={12} xl={12}>
            <div className={styles.errorMessage}>
              {errorMessage}
            </div>
          </Col>
        </Row>
      )
    }

    return rows
  }
}

export const CollectionViewBox = (props) => { return <FieldArray name={props.name} {...props} component={CollectionViewBoxClass} /> } // eslint-disable-line
export default CollectionViewBox
